module.exports = __webpack_public_path__ + "static/media/coupon.bc1ed53f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/coupon.png
 ** module id = 254
 ** module chunks = 0
 **/